import { render, staticRenderFns } from "./ModeloEtiqueta.vue?vue&type=template&id=77c9e4be&scoped=true&"
import script from "./ModeloEtiqueta.vue?vue&type=script&lang=js&"
export * from "./ModeloEtiqueta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c9e4be",
  null
  
)

export default component.exports